/* eslint-disable @typescript-eslint/no-explicit-any */
import { RootStore } from '.';
import { CancelablePromise } from '@talon/web/lib/api';

export abstract class BaseStore {
  rootStore: RootStore;
  q: <T>(request: CancelablePromise<T>) => Promise<T>;
  handleError: (e: any, customMsg?: string) => void;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.q = this.rootStore.addRequest;
    this.handleError = this.rootStore.handleError;
  }
}
